module.exports = __webpack_public_path__ + "static/media/Crazy-denim.01df06a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weird-wonderful/Crazy-denim.jpg
// module id = 363
// module chunks = 0